import URL from '@/tools/url';
import EventBus from '@/event-bus';
import jquery from 'jquery';
import _get from 'lodash/get';
import _merge from 'lodash/merge';
import cookie from '@/tools/get-cookie';
import createStorage from '@/storage';

/**
 * @memberof module:ajaxAPI/shop
 * @alias client
 *
 * @description
 * Получение информации о посетителе сайта. Если пользователь не залогинен, то дергаем инфу с json с актуальной информацией, и сохраняем его в кеш с актуальным токеном. Дальше сравниваем токен, если менялся, то опять дергаем аякс, если нет, то продолжаем брать данные из кеша, считая их актуальными.
 cookie клиента состоит из полей id клиента + поле updated_at с датой обновления данных клиента.
 *
 * @return {jquery.ajax}
 * Если пользователь залогинен, получим json с акутальной информацией о покупателе
 * { status: "ok", client: { // информация о покупателе }}
 *
 * В случае, если пользователь не залогинен, получим
 * { status: "error", message: "Not authorized", url: "/client_account/session/new" }
 *
 * @example
 * ajaxAPI.shop.client()
 *  .done(function (onDone) { console.log('onDone: ', onDone) })
 *  .fail(function (onFail) { console.log('onFail: ', onFail) })
 */

export default function(clear_storage) {
  var currency = (Shop) ? window.Shop.config.config.currency_code : '';
  var Store = createStorage({ name: 'client-' + currency });
  var _lang = URL.getKeyValue('lang') || '';
  var fields = { lang: _lang };
  var deferred = jquery.Deferred();

  if (cookie('client_token') == null) {
    return deferred.reject({
      message: 'Not authorized',
      url: 'client_account/session/new',
      authorized: false,
      status: 'error'
    });
  }

  Store.getItem('client')
      .then(function(clientAtStore) {
        var _insOVCached = _get(clientAtStore, 'client_token', '');

        if (clear_storage || _insOVCached !== cookie('client_token')) {
          jquery.getJSON('/client_account/contacts.json', fields).done(function(result) {
            switch (result.status) {
              case 'error':
                deferred.reject({
                  message: result.message,
                  url: result.url,
                  authorized: false
                });
                break;
              default: {
                result = _merge(result.client, { authorized: true });
                result.client_token = cookie('client_token');
                EventBus.publish('update:client', result);
                Store.setItem('client', result);
                deferred.resolve(result);
              }
            }
          })
          .fail(function(result) {
            console.log('ajaxAPI: Shop: client: get: fail: ', result);
            deferred.reject(result);
          });
        } else {
          deferred.resolve(clientAtStore);
        }
      });

  return deferred.promise();
}
